import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.BALANCE_OF_PAYMENT_SET_BALANCE_OF_PAYMENT_LIST]: (
    state,
    payload
  ) => {
    state.balanceOfPaymentList = payload.balanceOfPaymentList
  }
}

export default Mutations
